module.exports = __webpack_public_path__ + "lib/16GeA4fm.svg";